import React, { useEffect } from 'react'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import ReactGA from 'react-ga4'

import { Home } from './pages/Home'
import { NotFound } from './pages/NotFound'
import { Thanks } from './pages/Thanks'
import { Cookie } from './pages/Cookie'
import { Privacy } from './pages/Privacy'

import './styles/custom.sass'

// Initialize Google Analytics with consent mode
ReactGA.initialize('G-X7GRPJFQQP', {
  gaOptions: {
    anonymize_ip: true
  },
  gtagOptions: {
    anonymize_ip: true
  }
})

// Set default consent to denied
ReactGA.gtag('consent', 'default', {
  'analytics_storage': 'denied'
})

// Component to track page views
function Analytics() {
  const location = useLocation()

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search })
  }, [location])

  return null
}

function App() {

  return (
    <BrowserRouter>
      <Analytics />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/thank-you' element={<Thanks />} />
        <Route path='/cookie-policy' element={<Cookie />} />
        <Route path='/privacy-policy' element={<Privacy />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}

export { App }
